module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerm"
  }, [_c('a', {
    attrs: {
      "id": "part03_ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("III. THE RANGERS AND THE REPUBLIC")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_c('em', [_vm._v("1. HOUSTON AND LAMAR")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" Republic lasted from 1836 until Texas joined the Union in the latter part of 1845 or the early part of 1846. This was on the whole a turbulent period in which the policy towards the Indians and Mexicans, and therefore towards the Rangers, was in large measure determined by the military views of the president.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sam Houston, the hero of San Jacinto and the first president of the new republic, was without doubt one of the most original characters in Texas, an enigma to his friends and a sore trial to his enemies for whom he had small compassion. Houston was friendly to Indians. He had reason to regard them, for he had partaken of their hospitality, had lived their life, and, it is said, had become like an Indian in the interval between his disappearance in Tennessee and his appearance in Texas. Houston favored a policy of strict economy which influenced him to reduce the Texas military establishment to a minimum. Mirabeau Buonaparte Lamar’s administration intervened between Houston’s first and second terms. The contrasting character and antagonistic policy of these two strong-willed men were reflected in the frontier affairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Houston, favoring a policy of economy and of friendship for the Indians, did not augment the military organization. In fact, we hear little of Rangers during his first administration. Early in December, 1836, we find that congress passed a law ‘to protect the frontier.’ This law provided that the president was required to raise a battalion of mounted riflemen, two hundred and eighty men, for the protection of the frontier. Each man was to furnish a serviceable horse, a good rifle, and a brace of pistols if they could be procured. The same law provided that the president should cause to be erected such blockhouses, forts, and trading houses as he deemed necessary to prevent Indian depredations. It authorized the president to make treaties with the Indians and to appoint agents to reside among them, and to "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("distribute presents among them not to exceed in value twenty thousand dollars."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn01#part03_ch01fn1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" The question may arise as to whether ‘mounted riflemen’ were Rangers. The answer is found, apparently, in another law, passed five days later, specifying the pay of ‘Mounted Riflemen, now and hereafter in the ranging service on the frontier.’ It was retroactive and made provision for all officers and soldiers ‘who have been actually engaged in the ranging service since July, 1835.’"), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn01#part03_ch01fn2a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In June of the next year, 1837, congress passed a joint resolution authorizing President Houston to leave the capital for thirty days ‘to organize and set on foot the corps of mounted gun men’ authorized by congress for the protection of the northern frontier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An act providing for the ‘better protection of the northern frontier,’ approved June 12, provided for a corps of six hundred ‘mounted gun men,’ rank and file. They were to be raised by voluntary enlistment for a period of six months. Each man was to furnish a substantial horse, well shod all round, extra horseshoe nails, a good gun, two hundred rounds of ammunition, and other provisions and equipment except beef. Each six men were to furnish themselves a pack-horse. The corps was to be divided into three divisions, and if practicable, each division was to have attached to it a company of friendly Indians—Shawnees, Cherokees, Delawares, or some others—to serve as spies. The Indian spies were supplied with provisions and given such pay as might be agreed upon between them and the president. They were to be ‘paid in goods.’ It is quite obvious that this corps was intended for the Indian service, but the men are not spoken of as Rangers."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn01#part03_ch01fn3a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On May 15, 1838, Houston approved a bill providing for a ‘Corps of Regular Cavalry’ of two hundred and eighty men. The enlistment was to be from one to three years as the president might determine. The troops were to be used to protect the southwestern frontier from the approach of the Mexican forces."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn01#part03_ch01fn4a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lamar became president on December 10, 1838, and proceeded to reverse every policy that Houston had adopted. Where Houston pursued peace, Lamar, like his two namesakes (for his name was Mirabeau Buonaparte), favored war. Houston loved Indians, if he loved anything; Lamar hated them, but his hatred for Indians was probably secondary to his hatred for Houston.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("Lamar, in his message to congress, set forth his determination to handle the Indians with steel and lead. He stated that the proper policy to pursue towards them was one of absolute expulsion. ‘Nothing short of this will bring us peace or safety.’ The Indians could not be handled by treaty or by a policy of moderation and forbearance. The United States had pursued that policy in vain. ‘The white man and the red man cannot dwell in harmony together. Nature forbids it.’ The strongest of antipathies of color and modes of thinking separate them. ‘Knowing these things, I experience no difficulty in deciding on the proper policy to be pursued towards them. It is to push a rigorous war against them; pursuing them to their hiding places without mitigation or compassion, until they shall be made to feel that flight from our borders without hope of return, is preferable to the scourges of war.’"), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn02#part03_ch01fn5a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In preparation for this war, Lamar turned to the regular military establishments. He recognized that war was expensive, but he thought it was most commonly successful in proportion to judicious expenditures, and that it seldom succeeded under the guidance of ‘those who would value gold above liberty and life above honor.’"), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn02#part03_ch01fn6a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Lamar’s advocacy of the regular and militia arms implies that the irregular force which was coming to be called Texas Rangers would for a time be in abeyance or in eclipse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An act approved December 21, 1838, provided for a regiment of eight hundred and forty men, for a term of three years, for the protection of the northern and western frontier. There were to be fifteen companies of fifty-six men officered by a captain, a first and a second lieutenant. The regiment was to be divided into eight detachments and stationed in regular army posts along the line of the frontier from Red River to the Rio Grande.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The full provisions of this law were never carried into effect. Colonel William G. Cooke made an expedition to the Red River, and established one post near the Cross Timbers, but his expedition exhausted the appropriation, which amounted to three hundred thousand dollars, and nothing further was done."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn02#part03_ch01fn7a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" That this regiment was intended to form a part of the regular service is indicated by the long enlistment, the permanent location in forts, the fact that a part of the force was infantry, and the elaborate provision for a staff of officers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On December 29, 1838, Lamar approved a law for the ‘further protection of the Frontier against the Comanches and other Indians.’ "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("This law provided for eight companies of mounted volunteers for six months. The regiment was to receive the same pay as the mounted riflemen who were called into the ranging service under the law of December 10, 1836. The regiment was to have a colonel, a lieutenant colonel, and a major. These men may be called Rangers."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn03#part03_ch01fn8a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" In the following January a law was passed providing for one company of fifty-six Rangers to range on the frontier of Gonzales County."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn03#part03_ch01fn9a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Eight days later three similar companies were provided for Bastrop, Robertson, and Milam counties. The term of service was six months."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn03#part03_ch01fn10a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" The next day, January 24, a law was approved appropriating a million dollars for the protection of the frontier. The president was authorized to discharge all men in the military service save the regiment for the protection of the northern and western frontier, and the ordnance staff."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn03#part03_ch01fn11a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" This did not mean that the president was to discharge the Rangers, as the law provided that he could use the money for the defense of the country, and to carry into effect the act passed by the congress then in session. Two days later a law was signed providing for two companies of Rangers for the protection of the counties of San Patricio, Goliad, and Refugio."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn03#part03_ch01fn12a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two laws that may have some significance were passed and approved by David G. Burnet, during the absence of Lamar, in December, 1840. One provided for the transportation of ammunition to the post at San Antonio, and for the ‘purchase of three Spy Horses’ at that place. The second law authorized the president to appoint and commission three persons to raise fifteen men each to act as spies on the northern and western frontier."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn03#part03_ch01fn13a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" It is probable that these companies were commanded by John T. Price, Henry W. Karnes, and John C. Hays. Prior to this, however, congress passed a law providing for three hundred volunteers for three months to make a campaign up the Brazos against the hostile Indians. The men were to be armed and mounted as usual, but the term Ranger does not appear in the records.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The above provisions bring us to the end of Lamar’s term of office. Despite his liberal provisions for the regular military establishment, the ranging service continued. To be sure, it is often difficult to draw the line between Rangers and regular soldiers and militia. It is easy to see, however, that the Rangers were much more economical and they were probably more effective. Where a regular army, enlisted for from one to three years, required an expenditure of a million dollars, "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("a corps of Rangers could be raised for three months or six at small expense. Thus it was that the financial situation of Texas made a regular military establishment, a large force, impossible, and in spite of the attitude of the president, made the Rangers necessary. There was a vitality in the poverty of Texas which served to institutionalize the irregular partisan Texas fighter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Houston’s policy during his second administration was a reversal of Lamar’s and a return to one of peace. Houston appointed agents and sent them to the frontiers to ‘talk’ with the various tribes. Not only that, he disbanded the regular army, as he had practically done by furlough in his first term, and sold the navy, but he could not suspend entirely the corps of Indian fighters. He approved a law on January 29, 1842, providing for a company of mounted men to ‘act as Rangers’ on the southern frontier."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn04#part03_ch01fn14a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" On July 23 he was authorized to accept the services of one company on the Trinity and Navasoto. The men were to equip themselves and prepare for a ‘tour of not less than two months.’ The same act provided for two companies to range on the southwestern frontier. Small appropriations were made for both forces."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn04#part03_ch01fn15a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Houston’s opposition to a large military force is indicated by a law of January 16, 1843, providing for the organization of the Texas militia with a full corps of officers. Houston vetoed this bill, and it was passed over his veto."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn04#part03_ch01fn16a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" On the same day, however, he approved a bill for a company of mounted men to act as spies on the southwestern frontier until the militia bill could be put into effect."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn04#part03_ch01fn17a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The law of January 23, 1844, brings us to the emergence of a leader in the force. This law authorized John G. Hays to raise a company of mounted gunmen to act as Rangers on the western and southwestern frontier, from the county of Bexar to the county of Refugio and westward. This was evidently the company that made such a reputation for John C. Hays, whose activities will be noted elsewhere."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn04#part03_ch01fn18a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" On December 14, 1844, H. L. Kinney was authorized to raise a company for the protection of Corpus Christi."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch01fn19"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn04#part03_ch01fn19a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" In February of 1845 (during the administration of Anson Jones) a law was passed extending Hays’s authority. He was to have charge of a long frontier extending from Refugio and Goliad counties to Robertson and Milam. Hays was to command at Bexar. Ten men under a lieutenant were to be stationed in Robertson and Milam; fifteen men under a lieutenant in Travis county; thirty men under Hays as captain in San Antonio; and fifteen men under a lieutenant in Refugio and Goliad. The officers were to "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("be instructed ‘to scour the frontiers of their respective counties, protect them from incursions, and when concentrated in emergencies, to be under the command of Captain Hays,’ Provisions, horseshoes, and medicines were to be furnished by the government, not to exceed ten dollars for a man. The same law authorized Henry L. Kinney to raise, or continue, a company of forty men for the protection of Corpus Christi."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch02fn20"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn05#part03_ch02fn20a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" The last law pertaining to the Ranger service passed by congress appropriated $405.55, the sum Hays had spent for horseshoeing and the repair of arms during the year 1844."), _c('sup', [_c('a', {
    attrs: {
      "id": "part03_ch02fn21"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03_ch01fn05#part03_ch02fn21a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Thus ends the legal history of the Ranger force during the Republic. Though the story is tedious, it shows that the Rangers were always needed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dd876a1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part03_ch01.vue
// module id = 120
// module chunks = 0